/** Keep private asset IDs and Markdown control characters out of the note list. */
export function noteExcerpt(body: string): string {
  return body
    .replace(/!\[[^\]]*\]\([^)]*\)/g, " 画像 ")
    .replace(/^\s*[-*+] \[[ xX]\]\s*/gm, "")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/^\s{0,3}#{1,6}\s+/gm, "")
    .replace(/\\([\\`*_{}\[\]()#+\-.!<>~|])/g, "$1")
    .replace(/&#8203;/g, "")
    .replace(/&#58;/g, ":")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 90);
}
